/**
 * @generated SignedSource<<eecd0cf52f4f795c0b87ae6f6e8b93d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExperienceSettingsAccessSelect_ProductFragment$data = {
  readonly slug: string;
  readonly " $fragmentType": "ExperienceSettingsAccessSelect_ProductFragment";
};
export type ExperienceSettingsAccessSelect_ProductFragment$key = {
  readonly " $data"?: ExperienceSettingsAccessSelect_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsAccessSelect_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSettingsAccessSelect_ProductFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "be7204f96a9562f44dc14e381458e9f5";

export default node;
